import swal from 'sweetalert2'
import router from '../../router/router'
import store from '../../store/store'
import * as Sentry from '@sentry/vue'
import i18n from '../../locales/i18n'
import config from '@/config'
import { informarErroServidor, tratarErroDoBackParaString } from '../../utils'

const verificarSeEhSSOEhSincronizar = () => {
  const estaLogadoComSAML = store.state.accessData.cognitoInfo && store.state.accessData.cognitoInfo.isSamlLogin
  const estaLogadoComSSOSolar = store.state.accessData.solarInfo
  if (estaLogadoComSAML || estaLogadoComSSOSolar) {
    store.commit('marcacao/atribuiMostrarRelogio', false)
    store.commit('sincronizador/resetState')
    store.dispatch('sincronizador/fazerSincronizacaoWebSSO', {})
    return
  }
  router.push({ name: 'sincronizador' })
}

const tratarErroGenericoMarcacao = (erro) => {
  const erroTratado = tratarErroDoBackParaString(erro?.body?.detail)
  Sentry.captureException(erroTratado || erro)
  swal({
    type: 'error',
    text: erroTratado || i18n.t('componentes.marcacao.mensagemPadrao.textoPadraoFalha')
  }
  ).then(result => {
    verificarSeEhSSOEhSincronizar()
  })
}
export const tratarErroRepp = (erro, rota) => {
  const mensagemErro = informarErroServidor.montarMensagemDeErroServidor()
  const codigoErro = informarErroServidor.montarCodigoErroServidor('RP', rota, erro.status)
  if (erro.status >= 500) {
    swal({type: 'error', text: mensagemErro, footer: codigoErro})
      .then(result => {
        verificarSeEhSSOEhSincronizar()
      })
    return
  }

  if (erro.status === 0) {
    Sentry.captureEvent({
      message: 'Comunicação com REP-P falhou - timeout '
    })
    swal({type: 'error', text: mensagemErro, footer: codigoErro})
      .then(result => {
        verificarSeEhSSOEhSincronizar()
      })
    return
  }
  tratarErroGenericoMarcacao(erro)
}

export const tratarErroValidacaoPreMarcacao = (erro) => {
  const mensagemErro = informarErroServidor.montarMensagemDeErroServidor()
  const codigoErro = informarErroServidor.montarCodigoErroServidor('RP', 'VM', erro.status)
  if (erro.status >= 500) {
    swal({
      type: 'error',
      text: mensagemErro,
      footer: codigoErro
    }).then(result => {
      verificarSeEhSSOEhSincronizar()
    })
    return
  }

  if (erro.status === 400 && erro.body?.detail === 'Esse funcionário não existe no sistema ou ele não pode marcar ponto nesse local') {
    swal({
      type: 'error',
      text: i18n.t('componentes.marcacao.utils.errorFuncionarioNaoExiste'),
      footer: codigoErro
    }).then(result => {
      verificarSeEhSSOEhSincronizar()
    })
    return
  }

  if (erro.status === 0) {
    const tentativaValicaoPreMarcacao = store.state.marcacao.tentativasValidacaoPreMarcacao
    if (tentativaValicaoPreMarcacao === 3) {
      Sentry.captureEvent({
        message: 'Validação Pré Marcação falhou 3 vezes - timeout '
      })
      store.commit('marcacao/atribuiTentativasValidacaoPreMarcacao', 0)
      swal({
        type: 'error',
        text: mensagemErro,
        footer: codigoErro
      }).then(result => {
        verificarSeEhSSOEhSincronizar()
      })
      return
    }

    if (tentativaValicaoPreMarcacao === 2) {
      store.commit('marcacao/atribuiTentativasValidacaoPreMarcacao', tentativaValicaoPreMarcacao + 1)
      setTimeout(() => {
        store.dispatch('marcacao/validarPreMarcacao', 10000)
      }, 2000)
      return
    }
    store.commit('marcacao/atribuiTentativasValidacaoPreMarcacao', tentativaValicaoPreMarcacao + 1)
    setTimeout(() => {
      store.dispatch('marcacao/validarPreMarcacao')
    }, 2000)
    return
  }
  tratarErroGenericoMarcacao(erro)
}
export const tratarErroInformacoesMarcacao = (erro) => {
  if (erro.status >= 500) {
    swal({
      type: 'warning',
      text: i18n.t('componentes.marcacao.utils.tratarErroInformacoesMarcacao.texto')
    }).then(result => {
      verificarSeEhSSOEhSincronizar()
    })
    return
  }
  if (erro.status === 0 || (erro.status === 400 && erro.body?.detail === 'Essa marcação não existe')) {
    const tentativasBuscarDadosDaMarcacao = store.state.marcacao.tentativasBuscarDadosDaMarcacao

    if (tentativasBuscarDadosDaMarcacao === 3) {
      store.commit('marcacao/atribuiTentativasBuscarDadosDaMarcacao', 0)
      store.commit('marcacao/atribuiErroBuscarDados', true)
      router.push({name: 'confirmacaoPonto'})
      return
    }

    if (tentativasBuscarDadosDaMarcacao === 2) {
      store.commit('marcacao/atribuiTentativasBuscarDadosDaMarcacao', tentativasBuscarDadosDaMarcacao + 1)
      setTimeout(() => {
        store.dispatch('marcacao/buscarComprovanteMarcacaoDados', 10000)
      }, 2000)
      return
    }
    store.commit('marcacao/atribuiTentativasBuscarDadosDaMarcacao', tentativasBuscarDadosDaMarcacao + 1)
    setTimeout(() => {
      store.dispatch('marcacao/buscarComprovanteMarcacaoDados')
    }, 2000)
    return
  }
  tratarErroGenericoMarcacao(erro)
}
export const tratarErroEnvioInfosExtras = (erro) => {
  if (erro.status >= 500 || erro.status === 0) {
    const erroSentry = erro.status === 0 ? `${erro.status} - timeout` : erro.status
    const tentativasEnvioInfosExtras = store.state.marcacao.tentativasEnvioInfosExtras

    if (tentativasEnvioInfosExtras === 0) {
      setTimeout(() => {
        store.dispatch('marcacao/enviarInfosExtrasMarcacoes', { tempoParaFazerRequisicao: 5000, urlBaseParaRetry: config.gerenciadorUrlFallback })
        store.commit('marcacao/atribuiTentativasEnvioInfosExtras', tentativasEnvioInfosExtras + 1)
      }, 2000)
      return
    }

    if (tentativasEnvioInfosExtras === 1) {
      setTimeout(() => {
        store.dispatch('marcacao/enviarInfosExtrasMarcacoes', { tempoParaFazerRequisicao: 10000 })
        store.commit('marcacao/atribuiTentativasEnvioInfosExtras', tentativasEnvioInfosExtras + 1)
      }, 2000)
      return
    }

    if (tentativasEnvioInfosExtras === 2) {
      setTimeout(() => {
        store.dispatch('marcacao/enviarInfosExtrasMarcacoes', { tempoParaFazerRequisicao: 10000, urlBaseParaRetry: config.gerenciadorUrlFallback })
        store.commit('marcacao/atribuiTentativasEnvioInfosExtras', tentativasEnvioInfosExtras + 1)
      }, 2000)
      return
    }

    Sentry.captureEvent({
      message: `Erro ${erroSentry} ao enviar infos-extras do ponto - falhou ${tentativasEnvioInfosExtras} vezes`
    })

    store.dispatch('marcacao/buscarComprovanteMarcacaoDados')
    removerEventoParaPrevinirFechamentoDaPagina()
    store.commit('marcacao/atribuiErroEnvioInfosExtras', true)
    store.commit('marcacao/atribuiTentativasEnvioInfosExtras', 0)
  } else {
    tratarErroGenericoMarcacao(erro)
  }
}

export const tratarErroDeGeolocalizacao = (codigoErro) => ({
  '1': 'PERMISSAO_NEGADA',
  '2': 'LOCALIZACAO_INDISPONIVEL',
  '3': 'TEMPO_PARA_OBTER_LOCALIZACAO_ESGOTADO'
})[codigoErro] || 'ERRO_INESPERADO'

export const chaveInfosExtrasStorage = 'Infos-Extras'

export const verificarESetarInfosExtrasNoLocalStorage = (state, storage, chaveStorage, infosExtras) => {
  if (state.empregadoId !== null) {
    if (storage && storage.length) {
      const infoAtualEstaNoStorage = storage.find(ie => ie.marcacao_id === state.marcacaoId)
      if (!infoAtualEstaNoStorage) {
        window.localStorage.setItem(chaveStorage, JSON.stringify([...storage, ...infosExtras]))
      }
    } else {
      window.localStorage.setItem(chaveStorage, JSON.stringify(infosExtras))
    }
  }
}

export const verificarERemoverInfosExtrasDoLocalStorage = (state, storage, chaveStorage) => {
  const infoAtualEstaNoStorage = storage?.find(ie => ie.marcacao_id === state.marcacaoId)
  if (infoAtualEstaNoStorage) {
    const index = storage.indexOf(infoAtualEstaNoStorage)
    storage.splice(index, 1)
    window.localStorage.setItem(chaveStorage, JSON.stringify(storage))
  }
}

const eventoBeforeUnload = (evento) => {
  evento.returnValue = null
}

export const adicionarEventoParaPrevinirFechamentoDaPagina = () => {
  window.addEventListener('beforeunload', eventoBeforeUnload)
}

export const removerEventoParaPrevinirFechamentoDaPagina = () => {
  window.removeEventListener('beforeunload', eventoBeforeUnload)
}

export const formatarMomentoDaJornada = (momentoDaJornada) => {
  return {
    Entrada: i18n.t(
      'componentes.marcacao.utils.formatarMomentoDaJornada.entrada'
    ),
    Pausa: i18n.t(
      'componentes.marcacao.utils.formatarMomentoDaJornada.pausa'
    ),
    'Retorno Pausa': i18n.t(
      'componentes.marcacao.utils.formatarMomentoDaJornada.retornoDaPausa'
    ),
    // duplicando Retorno e Retorno Pausa, pois o valor pode vir de duas formas diferentes
    Retorno: i18n.t(
      'componentes.marcacao.utils.formatarMomentoDaJornada.retornoDaPausa'
    ),
    Saída: i18n.t(
      'componentes.marcacao.utils.formatarMomentoDaJornada.saida'
    )
  }[momentoDaJornada]
}
